var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.558,
    height: 37.187,
    viewBox: "0 0 52.558 37.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "youtube_4_",
    "data-name": "youtube (4)",
    d: "M1.161,34.953a6.665,6.665,0,0,0,4.572,4.633c5.4,1.471,35.66,1.475,41.14,0a6.689,6.689,0,0,0,4.572-4.633,76.042,76.042,0,0,0-.066-26.14l.066.429a6.665,6.665,0,0,0-4.572-4.633c-5.327-1.447-35.666-1.5-41.14,0A6.693,6.693,0,0,0,1.161,9.241a70.837,70.837,0,0,0,0,25.711Zm19.884-4.865V14.128L34.757,22.12Z",
    transform: "translate(0.015 -3.503)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f0af4bf0b507bfa2d273a051d5d89b78.svg";
export { ForwardRef as ReactComponent };